import { api } from '../config'

export const CONTROL_URL = {
  getControl: `${api.withAPI}administrative/api/v1/admin/app-config/current`,
  updateControl: `${api.withAPI}administrative/api/v1/admin/app-config`,
  updateRegion: `${api.withAPI}administrative/api/v1/admin/app-config/region-permissions`,
  updateDefaultPermissions: `${api.withAPI}administrative/api/v1/admin/app-config/default-region-permissions`,
}
